import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Icon from 'kingpin/atoms/Icon';
import Typography from 'kingpin/atoms/Typography';
import appRoutes from 'navigation/appRoutes';
import useInsightsChatBudget from 'hooks/useInsightsChatBudget';

// The top-level AI Insights entry point: a pill with a colourful gradient
// border (var(--color-ai-gradient)) that navigates to the full-page chat. The
// ring is a masked ::before so it follows the rounded corners cleanly — the
// gradient fills the element, then the mask punches out everything except a 1px
// frame. The button keeps a solid fill so only the ring shows. Shown only when
// the user has an effective AI budget; the account-level FeatureGate around it
// is the master switch.
const GradientButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 4px 10px;
  border: none;
  border-radius: 10px;
  background-color: var(--color-bg-primary);
  cursor: pointer;
  transition:
    transform 120ms ease,
    background-color 150ms ease;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 10px;
    padding: 1px;
    background: var(--color-ai-gradient);
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  &:hover {
    background-color: var(--color-bg-hover);
  }

  &:active {
    transform: translateY(1px);
  }
`;

const InsightsChatNavButton = () => {
  const { isEligible } = useInsightsChatBudget();
  const navigate = useNavigate();

  if (!isEligible) {
    return null;
  }

  return (
    <GradientButton
      type="button"
      onClick={() => navigate(appRoutes.loggedIn.insightsChat)}
      data-testid="insights-nav-button"
    >
      <Icon
        icon="sparkles"
        width={16}
        height={16}
        color="var(--color-text-secondary)"
      />
      <Typography.Body type="Button Text" color="var(--color-text-secondary)">
        Insights
      </Typography.Body>
    </GradientButton>
  );
};

export default InsightsChatNavButton;
